/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_RelocationInputs */

const en_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relocation assistance`)
};

const de_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umzugsunterstützung`)
};

const fr_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aide à la relocation`)
};

const es_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistencia para reubicación`)
};

const it_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistenza al trasferimento`)
};

const nl_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhuisvergoeding`)
};

const pl_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomoc w relokacji`)
};

const fi_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muuttotuki`)
};

const da_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyttehjælp`)
};

const sv_salary_negotiate_other_relocation = /** @type {(inputs: Salary_Negotiate_Other_RelocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flytthjälp`)
};

/**
* | output |
* | --- |
* | "Relocation assistance" |
*
* @param {Salary_Negotiate_Other_RelocationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_relocation = /** @type {((inputs?: Salary_Negotiate_Other_RelocationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_RelocationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_relocation(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_relocation(inputs)
	if (locale === "es") return es_salary_negotiate_other_relocation(inputs)
	if (locale === "it") return it_salary_negotiate_other_relocation(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_relocation(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_relocation(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_relocation(inputs)
	if (locale === "da") return da_salary_negotiate_other_relocation(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_relocation(inputs)
	return en_salary_negotiate_other_relocation(inputs)
});